// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"bb061613","21":"d91101bc","429":"4fe5e076","444":"589f8813","702":"2dbe652a","854":"69b3ddca"}[chunkId] + ".chunk.css";
};